import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import classNames from "classnames";
import { isEmpty } from 'lodash';

import { signOut } from "../../user/actions";
import { setSourceRoute, openModal } from "../actions";
import SlidingComponent from "../components/misc/SlidingComponent";
import {segmentEventTracker} from "../../../utils/SegmentEventTracker";
import {TrackEventName} from "../constants/SegmentEvents";

class NavBar extends Component {
  constructor(props) {
    super(props)

    this.state = {applicationOpen: false, accountOpen: false}
  }

  applyNowIconClassName(currentPath) {
    return classNames(
      "materialIcon --micro _marginRight-xxsmall",
      {'-primary': currentPath === this.props.location.pathname},
    );
  }

  tabClassnames(currentPath) {
    return classNames(
      {"-active": currentPath === this.props.location.pathname},
    );
  }

  newCustomer() {
    if(!this.props.user || !this.props.user.onboarding) return;
    if(this.props.user.kyc_verified_at_least_once) { return false }
    return !this.props.user.onboarding_finished && !this.props.user.onboarding.old_customer;
  }

  goToNotifications = () => {
    this.trackSegmentClick('notifications')
    if(this.props.location.pathname !== '/notifications') this.props.setSource(this.props.location.pathname);
    this.props.push('/notifications');
  }

  notificationClasses = () => {
    return classNames(
      'notifications',
      {'_newNotifications': this.props.unreadNotifications},
      {'_displayNone': !this.props.user.onboarding_finished},
    )
  }

  get zendeskUrl() {
    return 'https://firstcircle.zendesk.com'
  }

  get fchubUrl() {
    return `${process.env.REACT_APP_FCHUB_URL}/leads/${this.props.user.active_business_trustpass.lead_id}/brankas_statements`
  }

  get showFCHubLink() {
    if(this.props.user.active_business_trustpass) {
      return (<li>
        <a
          alt='Connect/View Your Bank Statements'
          data-path={this.fchubUrl}
          data-testid='fc-hub-link'
          href={this.fchubUrl}>
          Bank Statements
        </a>
      </li>)
    } else {
      return ""
    }
  }

  get shouldDisplayLinkToSupplierPayments() {
    if (isEmpty(this.props.fc_lead) || !this.props.user.auth_token) { return false }
    const { id, supplier_payments_enabled_at } = this.props.fc_lead;
    const {
      businessAccountEnabled,
      businessAccountCreated,
      withBusinessAccountConsent
    } = this.props.businessAccount;

    return id && supplier_payments_enabled_at && businessAccountCreated && businessAccountEnabled && withBusinessAccountConsent;
  }

  renderSupplierPaymentsLink = () => {
    if(!this.shouldDisplayLinkToSupplierPayments) { return null }
    if(!this.props.user.active_business_trustpass) { return null }

    return (
      <li>
        <a
          href={`${process.env.REACT_APP_FC_CONNECT_BASE_URL}/leads/${this.props.user.active_business_trustpass.lead_id}/home`}
          data-testid='navbar-supplier-payments'
          onclick={() => this.trackSegmentClick('business_account')}
          target='_blank'
        >
          Business Account
        </a>
      </li>

    )
  }

  onClickFAQ = (e) => {
    e.preventDefault()
    this.trackSegmentClick('faqs')
    const link = e.target
    const faq = window.open(link.href, link.target)
    faq.focus()
    this.setStateAndRedirect('accountOpen', null)
  }

  accountLiItems = () => {
    return ([
      <li>
        <Link to={{pathname: "/user_profile"}}
              data-testid='account-company-my-account'
              onClick={this.setAccountOpen}>
          User Details
        </Link>
      </li>,
      <li>
        <Link to={{pathname: '/company_information'}}
              data-testid='account-company-info'
              onClick={this.setAccountOpen}>
          Company Info
        </Link>
      </li>,
      <li>
        <Link to={{pathname: '/requirements'}}
              onClick={this.setAccountOpen}>
              Requirements
        </Link>
      </li>,
      this.showFCHubLink,
      <li>
        <Link to={{pathname: '/manage-alerts'}}
              data-testid='alerts-manager-list-item'>
          Manage Alerts
        </Link>
      </li>,
      <li>
        <a href={`${this.zendeskUrl}`}
          target='_blank'
          onClick={(e) => { e.persist(); this.onClickFAQ(e) }}>
          FAQs
        </a>
      </li>,
      <li>
        <a id='logout' onClick={this.setAccountOpen} data-testid='navbar-logout'>
          Log out
        </a>
      </li>
    ])
  };

  setApplicationOpen = (e) => {
    if(e.target.pathname){
      if(e.target.pathname.includes('invoice')){
        this.trackSegmentClick('upload_invoice')
      } else {
        this.trackSegmentClick('upload_po')
      }
    }
    this.setStateAndRedirect('applicationOpen', e.target.pathname)
  }

  setAccountOpen = (e) => {
    if(e.target.pathname){
      if(e.target.pathname.includes('user_profile')) {
        this.trackSegmentClick('my_account');
      } else if (e.target.pathname.includes('company_information')) {
        this.trackSegmentClick('company_info');
      } else if (e.target.pathname.includes('requirements')) {
        this.trackSegmentClick('requirements');
      } else if (e.target.pathname.includes('manage-alerts')) {
        this.trackSegmentClick('manage-alerts');
      }
    } else if (e.target.id === 'logout') {
      this.trackSegmentClick('logout')
      this.props.signOut()
    }
    this.setStateAndRedirect('accountOpen', e.target.pathname)
  }

  setStateAndRedirect = (stateKey, path) => {
    this.setState((prevState, props) => ({ [stateKey]: !prevState[stateKey]}), ()=> {
      if(path) {
        this.props.history.push(path)
      }
    })
  }

  trackSegmentClick(text) {
    let eventName;

    switch(text){
      case 'home':
        eventName = TrackEventName.NAVBAR_HOME_CLICKED;
        break;
      case 'applications':
        eventName = TrackEventName.NAVBAR_APPLICATIONS_CLICKED;
        break;
      case 'loan_plans':
        eventName = TrackEventName.NAVBAR_LOANS_CLICKED;
        break;
      case 'new_application':
        eventName = TrackEventName.NAVBAR_APPLY_CLICKED;
        break;
      case 'account':
        eventName = TrackEventName.NAVBAR_ACCOUNT_CLICKED;
        break;
      case 'my_account':
        eventName = TrackEventName.NAVBAR_ACCOUNT_MY_ACCOUNT_CLICKED;
        break;
      case 'upload_invoice':
        eventName = TrackEventName.NAVBAR_APPLY_UPLOAD_INVOICE_CLICKED;
        break;
      case 'upload_po':
        eventName = TrackEventName.NAVBAR_APPLY_UPLOAD_PO_CLICKED;
        break;
      case 'company_info':
        eventName = TrackEventName.NAVBAR_ACCOUNT_COMPANY_INFO_CLICKED;
        break;
      case 'logout':
        eventName = TrackEventName.NAVBAR_ACCOUNT_LOGOUT_CLICKED;
        break;
      case 'requirements':
        eventName = TrackEventName.NAVBAR_ACCOUNT_REQS_CLICKED;
        break;
      case 'manage-alerts':
        eventName = TrackEventName.NAVBAR_ACCOUNT_ALERTS_MANAGER_CLICKED;
        break;
      case 'referral':
        eventName = TrackEventName.REFERRAL_BUTTON_CLICKED;
        break;
      case 'business_account':
        eventName = TrackEventName.NAVBAR_BUSINESS_ACCOUNT_CLICKED;
        break;
      case 'notifications':
        eventName = TrackEventName.NOTIFICATIONS_BELL_CLICKED;
        break;
      case 'faqs':
        eventName = TrackEventName.NAVBAR_ACCOUNT_FAQS_CLICKED;
        break;
      default:
        return null;
    }

    segmentEventTracker.trackEvent(eventName);
  }

  openReferralModal = () => {
    this.trackSegmentClick('referral')
    this.props.openModal('referralModal');
  }

  addNewFeatureBadge = (newFeatureLink) => {
    if (process.env.REACT_APP_FEATURE_LINK === newFeatureLink) {
      return (
        <sup>
          <small class="ds-status -success">New</small>
        </sup>
      )
    }
  }

  render() {
    if(!this.props.user.id || !this.props.user.auth_token || this.newCustomer()) return <div />;

    return (
      <div className="ds-navigation _desktopOnly">
        <div className="grid --ultraWide">
          <nav className="navigationContent _desktop">
            <ul>
              <li className={this.tabClassnames("/")}>
                <Link to={{pathname: "/"}}
                      data-testid='navbar-dashboard'
                      onClick={
                        () => this.trackSegmentClick('home')
                      }>
                  Home
                </Link>
              </li>
              <li className={this.tabClassnames("/apply-now")}>
                <Link to={{pathname: "/apply-now"}}
                      data-testid='navbar-apply-now'
                      onClick={() => this.trackSegmentClick('new_application')}>
                  <i className={this.applyNowIconClassName('/apply-now')}>add_circle</i>
                  Apply Now
                </Link>
              </li>
              <li className={this.tabClassnames("/applications")}>
                <Link to={{pathname: "/applications"}}
                      data-testid='navbar-applications'
                      onClick={
                        () => this.trackSegmentClick('applications')
                      }>
                  Applications
                </Link>
              </li>
              <li className={this.tabClassnames("/loan_plans")}>
                <Link to={{pathname: "/loan_plans"}}
                      data-testid='navbar-loan-plans'
                      onClick={
                        () => this.trackSegmentClick('loan_plans')
                      }>
                  Loans
                </Link>
              </li>

              <li className={this.tabClassnames("/account")}>
                <Link to={{pathname: "/account"}}
                      data-testid='navbar-account'
                      onClick={
                        () => this.trackSegmentClick('account')
                      }>
                  Account
                </Link>
              </li>

              <li className={this.tabClassnames("/project-finder")}>
                <Link to={{pathname: "/project-finder"}}
                      data-testid='navbar-project-finder'
                      onClick={
                        () => this.trackSegmentClick('project-finder')
                      }>
                  <span>
                    Project Finder
                    {this.addNewFeatureBadge('/project-finder')}
                  </span>
                </Link>
              </li>

              {this.renderSupplierPaymentsLink()}
              {/* { !!process.env.REACT_APP_STAGING && */}
              {/*   <li> */}
              {/*     <a className="ds-btn -warning"> You're currently viewing {process.env.REACT_APP_STAGING} env </a> */}
              {/*   </li> */}
              {/* } */}

              <li className="referral">
                <a onClick={() => {this.openReferralModal()}}  data-testid='navbar-referral' className="ds-btn -secondary"> Refer and Get ₱ 10,000! </a>
              </li>
              <li className={this.notificationClasses()}>
                <a onClick={this.goToNotifications} data-testid='notifications-bell'>
                  <i className="materialIcon --small">
                    notifications_none
                  </i>
                </a>
              </li>
              <li className="account">
                <SlidingComponent
                  checkboxClass="navigationTrigger _desktop"
                  checkboxId="nvTd"
                  labelIconTextOff="arrow_drop_down"
                  labelIconTextOn="arrow_drop_up"
                  labelText={`${this.props.user.first_name} ${this.props.user.last_name}`}
                  liItems={this.accountLiItems()}
                  mobileView={false}
                  onClick={() => this.trackSegmentClick('account')}
                  open={this.state.accountOpen}
                  setOpen={this.setAccountOpen}
                  dataTestId='account-button'
                />
              </li>
            </ul>
          </nav>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    fc_lead: state.fc_lead,
    unreadNotifications: state.notifications.unreadNotifications,
    businessAccount: state.businessAccount,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    signOut: () => dispatch(signOut()),
    push: (url) => dispatch(push(url)),
    openModal: (name) => dispatch(openModal(name)),
    setSource: (url) => dispatch(setSourceRoute(url)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBar));



// WEBPACK FOOTER //
// ./src/features/shared/containers/NavBar.js